import type { VoidFunctionComponent, ReactNode } from 'react';
import Helmet from 'react-helmet';
import Loader from '../generic/Loader';
import NotFound from '../generic/NotFound';
import type { AsyncStatus } from '../../types';
import { PolicyType } from '../../types';
import { useIsSecurityEnabled } from '../../helpers/features';

type ListSecurityPoliciesPageProps = {
  renderPolicyList: (policyType: PolicyType) => ReactNode;
  status: AsyncStatus,
};

const ListSecurityPoliciesPage: VoidFunctionComponent<ListSecurityPoliciesPageProps> = ({
  renderPolicyList,
  status,
}) => {
  const hasSecurity = useIsSecurityEnabled();
  if (!hasSecurity) {
    return <NotFound />;
  }

  return (
    <div className="container margin-top">
      <Helmet title="Policies" />
      {status?.errors?.map(error => <div className="alert alert-error">{error}</div>)}
      {status?.loading ? <Loader /> : renderPolicyList(PolicyType.SECURITY)}
    </div>
  );
};

export default ListSecurityPoliciesPage;
